function initReadMore() {
  const containers = document.querySelectorAll('.js-read-more');

  containers.forEach((container) => {
    const content = container.querySelector('.js-read-more__content');
    const toggle = container.parentElement.querySelector('.js-read-more__toggle');

    if (!content || !toggle) return;

    const lines = parseInt(container.dataset.lines, 10) || 3;
    const lineHeight = parseFloat(window.getComputedStyle(content).lineHeight);
    const collapsedHeight = lineHeight * lines;

    function measure() {
      container.style.maxHeight = 'none';
      const naturalHeight = content.scrollHeight;
      container.style.maxHeight = '';

      if (naturalHeight <= collapsedHeight + 2) {
        // Content fits — hide toggle and fade
        toggle.classList.add('is-hidden');
        container.style.maxHeight = 'none';
        container.classList.add('is-expanded');
      } else {
        // Content overflows — collapse and show toggle
        toggle.classList.remove('is-hidden');
        container.style.maxHeight = collapsedHeight + 'px';
        container.classList.remove('is-expanded');
        toggle.setAttribute('aria-expanded', 'false');
      }
    }

    toggle.addEventListener('click', () => {
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

      const card = container.closest('.investment-solutions-card');
      if (card) {
        const grid = card.parentElement;
        if (grid && !grid.classList.contains('has-expanded')) {
          Array.from(grid.children).forEach((sibling) => {
            sibling.style.minHeight = sibling.offsetHeight + 'px';
          });
          grid.classList.add('has-expanded');
        }
      }

      if (isExpanded) {
        container.style.maxHeight = collapsedHeight + 'px';
        container.classList.remove('is-expanded');
        toggle.setAttribute('aria-expanded', 'false');
      } else {
        container.style.maxHeight = content.scrollHeight + 'px';
        container.classList.add('is-expanded');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });

    measure();
  });
}
window.addEventListener('DOMContentLoaded', () => {
  initReadMore();
});
